export const defaultSettings = [{
  class: 'color',
  section: 'Candle Color',
  swatches: [{
    chartType: 'Candle/Bar',
    class: 'colorDown',
    color: '',
    item: 'candleDown',
  }, {
    chartType: 'Candle/Bar',
    class: 'colorUp',
    color: '',
    item: 'candleUp',
  }],
},
{
  class: 'wick',
  section: 'Candle Wick',
  swatches: [{
    chartType: 'Candle/Bar',
    class: 'wickDown',
    color: '',
    item: 'wickDown',
  }, {
    chartType: 'Candle/Bar',
    class: 'wickUp',
    color: '',
    item: 'wickUp',
  }],
},
{
  class: 'border',
  section: 'Candle Border',
  swatches: [{
    chartType: 'Candle/Bar',
    class: 'borderDown',
    color: '',
    item: 'borderDown',
  }, {
    chartType: 'Candle/Bar',
    class: 'borderUp',
    color: '',
    item: 'borderUp',
  }],
},
{
  class: 'lineBarChart',
  section: 'Line/Bar Chart',
  swatches: [{
    chartType: 'Line',
    class: 'lineBar',
    color: '',
    item: 'lineBar',
  }],
},
{
  class: 'mountainChart',
  section: 'Mountain Color',
  swatches: [{
    chartType: 'Mountain',
    class: 'mountain',
    color: '',
    item: 'mountain',
  }],
},
{
  class: 'background',
  section: 'Background',
  swatches: [{
    chart: 'Background',
    class: 'chartBackground',
    color: '',
    item: 'chartBackground',
  }],
},
{
  class: 'gridLines',
  section: 'Grid Lines',
  swatches: [{
    chart: 'Grid Lines',
    class: 'lines',
    color: '',
    item: 'lines',
  }],
},
{
  class: 'dateDividers',
  section: 'Date Dividers',
  swatches: [{
    chart: 'Grid Dividers',
    class: 'dividers',
    color: '',

    item: 'dividers',
  }],
},
{
  class: 'axisText',
  section: 'Axis Text',
  swatches: [{
    chart: 'Axis Text',
    class: 'axis',
    color: '',
    item: 'axis',
  }],
},
];

export interface IBuiltinThemes {
  builtIn?: boolean,
  className?: string,
  name: string
}

export const builtinThemes: IBuiltinThemes[] = [{
	builtIn: true,
	className: 'ciq-night',
	name: 'Night',
},
{
	builtIn: true,
	className: 'ciq-day',
	name: 'Day',
}];
